/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileDocument = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M22 2H2v8h20z" />
        <path
          clipRule="evenodd"
          d="M9 13H7v-2h2zm8 0h-6v-2h6zm0 3H7v-2h10zm-4 3H7v-2h6z"
          fillRule="evenodd"
        />
      </g>
      <path
        d="M5.336 8.446V4.084H6.8c.712 0 1.25.184 1.614.552s.546.912.546 1.632c0 .712-.182 1.254-.546 1.626-.36.368-.898.552-1.614.552zm1.452-3.6h-.516v2.838h.516c.404 0 .704-.114.9-.342.2-.232.3-.59.3-1.074s-.098-.842-.294-1.074-.498-.348-.906-.348zm5.327 3.684c-.652 0-1.156-.196-1.512-.588-.352-.396-.528-.956-.528-1.68 0-.716.178-1.272.534-1.668S11.467 4 12.115 4s1.15.198 1.506.594.534.952.534 1.668c0 .724-.176 1.284-.528 1.68-.352.392-.856.588-1.512.588zm0-.798c.364 0 .634-.126.81-.378.18-.252.27-.616.27-1.092s-.09-.838-.27-1.086c-.176-.252-.446-.378-.81-.378s-.636.126-.816.378c-.176.248-.264.61-.264 1.086s.088.84.264 1.092c.18.252.452.378.816.378zm6.549-.24v.78a2.819 2.819 0 0 1-.546.18c-.204.052-.43.078-.678.078-.7 0-1.23-.198-1.59-.594-.36-.4-.54-.974-.54-1.722 0-.46.088-.854.264-1.182.176-.332.426-.586.75-.762.324-.18.71-.27 1.158-.27.212 0 .408.022.588.066s.338.1.474.168v.792a3.724 3.724 0 0 0-.552-.168 2.153 2.153 0 0 0-.444-.048c-.412 0-.728.122-.948.366s-.33.59-.33 1.038c0 .484.108.858.324 1.122.216.26.534.39.954.39.168 0 .338-.018.51-.054.176-.04.378-.1.606-.18z"
        fill="currentcolor"
      />
      <path
        clipRule="evenodd"
        d="M2 9h2v11h16V9h2v13H2v-2z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgFileDocument as FileDocument };
